import { useDeviceType } from '@cian/ui-kit/responsive';
import { setCookie } from '@cian/utils/lib/browser/cookie';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackListingButtonClick } from '../../../../../packages/Listing';
import { IJsonQuery } from '../../../../../packages/api-models/common/json_query';
import { ListingButton } from '../../../components/Navigation';
import { COOKIE_EXPIRES, COOKIE_NAME } from '../../../constants/datesModal';
import { selectDatesModalState } from '../../../selectors/filters/datesModal/selectDatesModalState';
import { selectListingUrl } from '../../../selectors/urls';
import { IApplicationState } from '../../../types/redux';
import { EResultsStatus } from '../../../types/results';
import { useApplicationContext } from '../../ApplicationContext';

export const ListingButtonContainer: React.FC = () => {
  const url = useSelector(selectListingUrl);
  const {
    config,
    custom: { subdomain },
  } = useApplicationContext();
  const isDatesModalAutoOpenRSEnabled = config.get<boolean>('Dailyrent.DatesAutoOpen.Enabled');
  const targetSubdomain = useSelector<IApplicationState, string>(state => state.results.subdomain);
  const jsonQuery = useSelector<IApplicationState, IJsonQuery>(state => state.results.jsonQuery);
  const deviceType = useDeviceType();
  const [targetDomain, setTargetDomain] = React.useState(`${targetSubdomain}.cian.ru`);
  const resultsStatus = useSelector<IApplicationState, EResultsStatus>(state => state.results.status);
  const { skipAutoOpen } = useSelector(selectDatesModalState);
  const needSkipFlag = isDatesModalAutoOpenRSEnabled && skipAutoOpen;

  const isLoading = resultsStatus === EResultsStatus.Loading;

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      event.preventDefault();

      if (isLoading) {
        return;
      }

      if (needSkipFlag) {
        setCookie(COOKIE_NAME, 'true', { domain: '.cian.ru', expires: new Date(Date.now() + COOKIE_EXPIRES) });
      }

      const href = event.currentTarget.href;
      trackListingButtonClick(jsonQuery);

      setTimeout(() => {
        if (deviceType === 'desktop') {
          window.open(href, '_blank');
        } else {
          document.cookie = 'flavour=mobile;domain=.cian.ru;path=/';
          window.location.href = href;
        }
      }, 300);
    },
    [deviceType, isLoading, jsonQuery, needSkipFlag],
  );

  React.useEffect(() => {
    setTargetDomain(window.location.hostname.replace(`${subdomain}.`, `${targetSubdomain}.`));
  }, [subdomain, targetSubdomain]);

  return <ListingButton url={`//${targetDomain}${url}`} onClick={handleClick} loading={isLoading} />;
};
